var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyCodeBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.50859 19.3407V19.8407H2.00859H15.8728H16.3728V19.3407V5.32461V4.82461H15.8728H2.00859H1.50859V5.32461V19.3407ZM19.3855 16.1757H19.8855V15.6757V1.65929V1.15929H19.3855H5.52098H5.02098V1.65929V2.5821C5.02098 2.76933 4.87248 2.91157 4.70053 2.91157C4.52871 2.91157 4.38007 2.76912 4.38007 2.5821V0.829466C4.38007 0.642449 4.52871 0.5 4.70053 0.5H20.206C20.3778 0.5 20.5264 0.642449 20.5264 0.829466V16.5052C20.5264 16.6922 20.3778 16.8347 20.206 16.8347H18.5401C18.3683 16.8347 18.2197 16.6922 18.2197 16.5052C18.2197 16.318 18.3682 16.1757 18.5401 16.1757H19.3855ZM16.6936 20.5H1.18813C1.01617 20.5 0.867676 20.3578 0.867676 20.1705V4.49514C0.867676 4.30791 1.01617 4.16568 1.18813 4.16568H16.6936C16.8654 4.16568 17.014 4.30813 17.014 4.49514V20.1705C17.014 20.3576 16.8654 20.5 16.6936 20.5Z",
    fill: "#3399FF",
    stroke: "#4888C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyCodeBlue);
export default __webpack_public_path__ + "static/media/copy_code_blue.16f2769f3f674c94754821682a5152dc.svg";
export { ForwardRef as ReactComponent };